var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseBurger = function SvgCloseBurger(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_32dp_Icon_Navigation_Close",
    "data-name": "32dp Icon/Navigation/Close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": "\\uD83C\\uDFA8 Color",
    d: "M0,26a1.838,1.838,0,0,1,.562-1.375L11.188,14,.562,3.375A2.06,2.06,0,0,1,.062,2,1.908,1.908,0,0,1,2,.062a2.06,2.06,0,0,1,1.375.5L14,11.188,24.625.562A1.838,1.838,0,0,1,26,0a1.974,1.974,0,0,1,2,2,1.688,1.688,0,0,1-.625,1.375L16.812,14,27.375,24.625A1.688,1.688,0,0,1,28,26a1.961,1.961,0,0,1-1.938,2,1.829,1.829,0,0,1-1.437-.625L14,16.812,3.375,27.375A1.829,1.829,0,0,1,1.938,28,1.961,1.961,0,0,1,0,26Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseBurger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-burger.a122a9b7cca7c3bf7db6e80f81ca4e7a.svg";